(() => {
  'use strict';
  const form = document.querySelector('#quote-form');
  if (!form) return;
  const fileInput = document.querySelector('#survey');
  const fileList = document.querySelector('#file-list');
  const fileError = document.querySelector('#file-error');
  const uploadBox = document.querySelector('.upload-box');
  const receipt = document.querySelector('#request-success');
  const request = document.querySelector('#quote-request');
  const sendStatus = document.querySelector('#send-status');
  function showReceipt() {
    form.hidden = true;
    receipt.hidden = false;
    document.querySelector('#request-title').focus({preventScroll: true});
    request.scrollIntoView({block: 'start', behavior: 'auto'});
  }
  const formError = document.querySelector('#form-error');
  form.addEventListener('input', event => {
    event.target.setCustomValidity?.('');
    formError.hidden = true;
  });
  let files = [];
  let submissionId = crypto.randomUUID();
  let sending = false;
  let sent = false;
  let started = false;
  function analytics(eventName, parameters = {}) {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() && typeof window.gtag === 'function') {
        window.gtag('event', eventName, {send_to: 'G-LYB92T604T', form_name: 'windows_doors_quote', ...parameters});
      }
    } catch (_) {}
  }
  function startTracking() {
    if (started) return;
    started = true;
    analytics('windows_quote_start');
  }
  form.addEventListener('change', startTracking);
  form.addEventListener('input', startTracking);
  const submit = form.querySelector('[type=submit]');
  function setProductFields(value) {
    const windows = value === 'Windows' || value === 'Windows and doors';
    const doors = value === 'Doors' || value === 'Windows and doors';
    for (const [id, show] of [['window-count-wrap', windows], ['door-count-wrap', doors]]) {
      const node = document.getElementById(id);
      node.hidden = !show;
      if (node.tagName === 'FIELDSET') node.disabled = !show;
      else node.querySelector('input').disabled = !show;
    }
  }
  form.addEventListener('change', event => {
    if (event.target.name === 'products') setProductFields(event.target.value);

  });
  function renderFiles() {
    fileList.replaceChildren();
    files.forEach((file, index) => {
      const row = document.createElement('li');
      const name = document.createElement('span');
      name.textContent = `${file.name} (${(file.size / 1024 / 1024).toFixed(1)} MB)`;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', `Remove ${file.name}`);
      remove.addEventListener('click', () => { files.splice(index, 1); renderFiles(); });
      row.append(name, remove); fileList.append(row);
    });
  }
  function addFiles(selected) {
    const candidates = [...files];
    let error = '';
    for (const file of selected) {
      if (!/\.(pdf|jpe?g|png|heic)$/i.test(file.name)) { error = 'Use a PDF, JPG, PNG or HEIC file.'; break; }
      if (file.size > 10 * 1024 * 1024) { error = 'Each file needs to be 10 MB or less.'; break; }
      if (!candidates.some(item => item.name === file.name && item.size === file.size && item.lastModified === file.lastModified)) candidates.push(file);
    }
    if (!error && candidates.length > 5) error = 'Choose up to 5 files.';
    if (!error && candidates.reduce((size, file) => size + file.size, 0) > 20 * 1024 * 1024) error = 'Your files need to total 20 MB or less.';
    fileError.textContent = error;
    fileError.hidden = !error;
    if (!error) files = candidates;
    renderFiles();
    fileInput.value = '';
  }
  fileInput.addEventListener('change', () => addFiles([...fileInput.files]));
  for (const event of ['dragenter', 'dragover']) uploadBox.addEventListener(event, e => { e.preventDefault(); uploadBox.classList.add('dragging'); });
  uploadBox.addEventListener('dragleave', () => uploadBox.classList.remove('dragging'));
  uploadBox.addEventListener('drop', event => { event.preventDefault(); uploadBox.classList.remove('dragging'); addFiles([...event.dataTransfer.files]); });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (sending) return;
    if (sent) { showReceipt(); return; }
    startTracking();
    for (const name of ['name', 'company', 'email', 'phone']) form.elements[name].value = form.elements[name].value.trim();
    const postcode = form.elements.postcode.value.toUpperCase().replace(/\s+/g, '');
    form.elements.postcode.value = postcode.length > 3 ? `${postcode.slice(0, -3)} ${postcode.slice(-3)}` : postcode;
    const phone = form.elements.phone;
    const digits = phone.value.replace(/\D/g, '').length;
    phone.setCustomValidity(phone.value && (digits < 7 || digits > 15) ? 'Enter a phone number with 7 to 15 digits.' : '');
    if (!form.checkValidity()) {
      const invalid = form.querySelector('input:invalid, textarea:invalid');
      const labels = {name: 'your name', email: 'your email address', phone: 'your phone number', postcode: 'the job postcode', windows: 'the number of windows', doors: 'the number of doors'};
      formError.textContent = invalid?.name === 'products' ? 'Please select Windows, Doors or Both.' : `Please check ${labels[invalid?.name] || 'the highlighted field'}.`;
      formError.hidden = false;
      invalid?.focus();
      analytics('windows_quote_error', {error_type: 'validation'});
      form.reportValidity();
      return;
    }
    formError.hidden = true;
    const data = new FormData(form);
    const summary = document.querySelector('#request-summary');
    summary.replaceChildren();
    const rows = [
      ['Products', data.get('products')],
      ['Windows', data.has('windows') ? (data.get('windows') || 'Quantity to confirm') : ''],
      ['Doors', data.has('doors') ? (data.get('doors') || 'Quantity to confirm') : ''],
      ['Survey / photos', files.length ? files.map(file => file.name).join('\n') : 'None added'],
      ['Job details', data.get('requirements')],
      ['Name', data.get('name').trim()], ['Company', data.get('company').trim()],
      ['Email', data.get('email').trim()], ['Phone', data.get('phone').trim()],
      ['Job postcode', data.get('postcode').trim().toUpperCase()]
    ];
    rows.filter(([, value]) => value).forEach(([label, value]) => {
      const row = document.createElement('div'); const title = document.createElement('dt'); const detail = document.createElement('dd');
      title.textContent = label; detail.textContent = value; row.append(title, detail); summary.append(row);
    });
    data.delete('survey');
    data.set('submission_id', submissionId);
    const query = new URLSearchParams(location.search);
    for (const name of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'ad_id', 'adset_id', 'campaign_id']) data.set(name, query.get(name) || '');
    files.forEach(file => data.append('files', file, file.name));
    sending = true; submit.disabled = true; submit.textContent = 'Sending your enquiry…';
    form.setAttribute('aria-busy', 'true');
    sendStatus.textContent = 'Sending your enquiry. Please keep this page open.';
    try {
      const response = await fetch('https://tpc-windows-quote-intake.rob-henderson1209.workers.dev/api/quote', {method: 'POST', body: data, signal: AbortSignal.timeout(120000)});
      const result = await response.json();
      if (!response.ok || !result.ok || !result.leadId) throw Error(result.error || 'Please try again.');
      const reference = document.querySelector('#request-reference');
      reference.textContent = `${reference.dataset.label} ${result.leadId}`;
      sent = true; showReceipt();
      const isTest = /^TEST(?:\b|[_-])/i.test(data.get('name').trim()) || /^(internal|qa)$/i.test(query.get('utm_source') || '') || /^(qa|test)$/i.test(query.get('utm_medium') || '');
      analytics(isTest ? 'windows_quote_test' : 'generate_lead', {lead_source: 'website_form'});
      if (!isTest) analytics('windows_quote_success', {lead_source: 'website_form'});
      // Count acknowledged enquiries only; respect Shopify marketing/sharing consent.
      // No contact details, notes, postcode or file links are sent to Meta.
      try {
        const privacy = window.Shopify?.customerPrivacy;
        if (privacy?.marketingAllowed() && privacy?.saleOfDataAllowed() && typeof window.fbq === 'function') {
          window.fbq('consent', 'grant');
          window.fbq(isTest ? 'trackSingleCustom' : 'trackSingle', '4259446144322997', isTest ? 'WindowsQuoteTest' : 'Lead', {
            content_name: 'Windows and Doors Trade Quote',
            form_name: 'windows_doors_quote',
            lead_source: 'website_form'
          }, {eventID: `windows-quote-${submissionId}`});
        }
      } catch (_) { /* Enquiry receipt is independent of attribution availability. */ }

    } catch (error) {
      analytics('windows_quote_error', {error_type: error.name === 'TimeoutError' ? 'timeout' : 'delivery'});
      formError.textContent = error.name === 'TimeoutError' ? 'We could not confirm your enquiry yet. Please try again; your details and files are still here.' : error.message === 'Failed to fetch' ? 'Please check your connection and try again. Your details and files are still here.' : error.message;
      formError.hidden = false; formError.scrollIntoView({block: 'center', behavior: 'smooth'});
    } finally { sending = false; submit.disabled = sent; submit.textContent = sent ? 'Enquiry sent' : 'Send quote request'; form.setAttribute('aria-busy', 'false'); sendStatus.textContent = ''; }
  });
  document.querySelector('#new-request').addEventListener('click', () => {
    form.reset(); files = []; renderFiles(); setProductFields('');
    submissionId = crypto.randomUUID(); sent = false; started = false;
    receipt.hidden = true; form.hidden = false;
    formError.hidden = true; fileError.hidden = true;
    submit.disabled = false; submit.textContent = 'Send quote request';
    form.focus({preventScroll: true}); request.scrollIntoView({block: 'start', behavior: 'auto'});
  });
  document.querySelector('#cookie-settings').addEventListener('click', () => {
    window.privacyBanner?.showPreferences();
  });
  const sticky = document.querySelector('.mobile-quote-cta');
  const hero = document.querySelector('.hero-copy');
  let heroVisible = true, requestVisible = false, consentVisible = false;
  function updateSticky() {
    sticky.hidden = heroVisible || requestVisible || consentVisible || sent;
  }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === request) requestVisible = entry.isIntersecting;
      }
      updateSticky();
    });
    observer.observe(hero); observer.observe(request);
  }
  function observeConsent() {
    consentVisible = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')].some(node => node.getBoundingClientRect().height > 0 && getComputedStyle(node).visibility !== 'hidden');
    updateSticky();
  }
  new MutationObserver(observeConsent).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']});
  observeConsent();
})();
